import React from "react";
import noDataFound from "../assets/error-screens/no_data_found.svg";
import { useTranslation } from "react-i18next";
import "./no_data_found.css";

const NoDataFound = ({hideSubLabel=false, mainHeading=""}) => {
    const { t, i18n } = useTranslation();
    return (
        <div className="no-data-found-container d-flex justify-content-center">
            <div className="no-data-found-content">
                <div className="w-100"><img src={noDataFound} style={{width: 'inherit'}} alt="no data found" className="mx-auto d-block" /></div>
                <div className="no-data-found-main-heading">{mainHeading || t('auditRequest.no_data_found_label')}</div>
                {!hideSubLabel && <div className="no-data-found-sub-heading">{t('auditRequest.no_data_found_sub_label')}</div>}
            </div>
        </div>
    );
};
export default NoDataFound;